<template>
    <v-content class="login">
        <!-- logo -->
        <v-row align-content="center" justify="center" no-gutters class="logo">
            <img :src="init.top_logo_image" height="50px" style="width:auto; max-width:100%;" />
        </v-row>
    
        <div class="px-3 mt-10">
            <div class=" text-center">
                <h1 class="subtitle-1 font-weight-black mb-10" style="border-bottom: solid 1px #000; display: inline-block;">パスワードを忘れた方</h1>
            </div>
            <p class="body-2 mb-5">新しいパスワードを再設定するURLをメールいたしますので、ご登録時のメールアドレスを入力してください。</p>

            <ValidationObserver ref="observer">
            <v-row class="mb-10">
                <v-col cols="12" sm="6" class="pb-0">
                    <p class="subtitle-2 font-weight-black ma-0">メールアドレス</p>
                    <ValidationProvider v-slot="{ errors }" name="メールアドレス" rules="required|email">
                    <v-text-field label single-line outlined dense v-model="login_id" name="login_id" :error-messages="errors" required>
                    </v-text-field>
                    </ValidationProvider>
                </v-col>
            </v-row>
    
            <div class="text-center">
                <v-btn rounded class="maincolor-bg default_button mb-5" @click.stop="sendForget">再設定メールを送信</v-btn>
                <v-btn rounded class="caption font-weight-black mb-10" style="background-color:#EFEFEF;" to="/login/index">ログイン画面に戻る</v-btn>
                <p class="text-left caption pt-10">【パスワード変更メールが届かない場合】<br><br>
                  ＜メールアドレス入力前の注意点＞<br>
                  ・配信ドメイン『@usen.com 』を受信できるよう設定してください。<br>
                  ・迷惑メール防止機能は、一時的に解除、もしくは強度を下げてください。<br>
                  ・自分に空メールを送信し、そのメールが受信できるか確認してください。<br><br>
                  ＜メールアドレス入力時の注意点＞<br>
                  スペルミス、打ち間違い、記号の入力ミス(ドット「．」ハイフン「－」などの入力数間違いなど)にご注意ください。
                </p>
            </div>
            </ValidationObserver>

            <div class="text-center caption pt-10">
                <p class="caption" v-if="init.inquiry_mail">
                    <v-icon>far fa-envelope</v-icon> <a :href="'mailto:'+init.inquiry_mail">お問い合わせ</a>
                </p>
            </div>
      
            <p class="text-center" v-if="init.copyright" style="font-size: 12px; margin-top:60px;">© {{init.copyright}} All right reserved.</p>
      
        </div>

        <v-overlay :value="loading">
          <v-progress-circular :size="80" :width="2" class="maincolor" indeterminate></v-progress-circular>
        </v-overlay>

        <v-dialog v-model="okDialog" persistent>
          <v-card class="text-center pa-5">
            <h3 class="subtitle-1 font-weight-bold mb-10">ご指定のメールアドレスに<br>設定URLを送信しました。</h3>
            <p class="body-2 mb-10">メール内に記載されたURLより<br>パスワードの再設定をおこなってください。</p>
            <div class="text-center">
              <v-btn rounded class="maincolor-bg default_button" to="/login/index">ログイン画面に戻る</v-btn>
            </div>
          </v-card>
        </v-dialog>
    </v-content>
</template>

<script>
import { required, email } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
setInteractionMode('eager')
extend('required', {
  ...required,
  message: '{_field_} は必須項目です。',
})

extend('email', {
  ...email,
  message: '正しいメールアドレス形式ではありません',
})

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data: () => ({
    init: [],
    loading: false,
    okDialog: false,
    login_id: '',
    result: '',
    resultapi: [],
  }),
  created() {
    this.init = this.storageGet('*')
 },
  methods : {
    sendForget: function(){
      this.$refs.observer.validate().then(async result => {
        if (result) {
          try {
            //loadingを表示
            this.loading = true
            
            // 事業者情報取得API実行
            var business_service_req = {
              params: {
                'sid': this.storageGet('sid')
              }
            }
            var business_service_res = await this.apiCall('/business-service/get-info', business_service_req)

            // パスワードリセット申請API実行
            var req = { 
              sid: this.init.sid,
              service_cd: this.init.service_cd,
              login_id: this.login_id,
              shop_name: this.storageGet('shop_name'),
              email: business_service_res.data.email,
              email_name: business_service_res.data.email_name
            }
            var res = await this.apiCall('/request-password-reset', req, 'post', 2);
            this.$set(this, 'resultapi', res)
            //console.log(res)
            /* apiでエラーであってもエラー画面は出さない
            if (!res) {
              this.loading = false
              return false
            }
            
            if(this.resultapi.status == 200){
              this.loading = false
              this.okDialog = true
            }else{
              throw "login error"
            }
            */
            if(res && res.status != 703){ //メール送信ができなかった場合以外は、OKダイアログを表示する
              this.loading = false
              this.okDialog = true
            }
          } catch(e) {
            this.loading = false
            this.callDialog('エラー', this.resultapi.message, 3);
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.fontsize12>>>label {
    font-size: 12px;
}

a {
    color: #333333;
}
</style>
